import React from 'react';
import { Stack } from '@mui/material';
import VidoeUploadProgressBar from './VideoUploadProgressBar';
import { useApi } from 'hooks';
import {
    convertVideoFormat,
    VideoFormat,
} from './VideoUploadProgressBar.types';
import { components } from 'apis';
import { UseQueryResult } from '@tanstack/react-query';
type GetVideoUploadProgressResponse =
    components['schemas']['GetVideoUploadProgressResponse'];
interface VideoUploadProgressProps {
    videoId: string;
    videoTitle: string;
}
const VidoeUploadProgress: React.FC<VideoUploadProgressProps> = (props) => {
    const { api } = useApi();
    const progressQuery: UseQueryResult<GetVideoUploadProgressResponse> =
        api.useQuery(
            'get',
            '/media/{id}/uploadProgress',
            {
                params: {
                    path: { id: props.videoId },
                },
            },
            {
                enabled: props.videoTitle !== '',
                refetchInterval: 8000,
            },
        );
    console.log(progressQuery);
    return (
        <Stack>
            {(progressQuery.data?.videoProgress ?? []).map(
                (progress, index) => (
                    <VidoeUploadProgressBar
                        quality={convertVideoFormat(progress.quality)}
                        progress={progress.percentComplete ?? 0}
                        status={progress?.status ?? 'NOT_STARTED'}
                        key={index.toString()}
                        errorMessage={progressQuery?.error?.message ?? ''}
                        title={props.videoTitle}
                    />
                ),
            )}
        </Stack>
    );
};

export default VidoeUploadProgress;
